<template>
  <v-container
    fluid
    class="pa-7">
    <v-btn
      color="primary"
      class="mb-6 pl-0"
      text
      @click="$router.back(-1)">
      <v-icon
        class="mr-2"
        small>
        $vuetify.icons.chevronLeft
      </v-icon>
      {{ $vuetify.lang.t('$vuetify.back') }}
    </v-btn>
    <HeaderComponent
      class="pb-8"
      :title="`Soubor: ${fileName}`" />

    <ShipmentScanTableComponent
      :data="shipmentsForTable"
      :fileId="fileId"
      :isLoading="shipmentsLoading" />
  </v-container>
</template>

<script>
import { EcoChallengeFileApiService } from "@/common/services/eco-challenge-file.api.service";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import { mapActions, mapGetters } from "vuex";
import ShipmentScanTableComponent from "@/components/global/ShipmentScanTableComponent.vue";

export default {
  name: "FileDetail",

  components: {ShipmentScanTableComponent, HeaderComponent },

  data() {
    return {
      /**
       * @type {Array<EcoChallengeFileOrdersModel>}
       */
      shipmentsForTable: [],
      shipmentsLoading: false,
    }
  },

  computed: {
    ...mapGetters({ files: "files/getAllItems" }),

    fileId() {
      return Number(this.$route.params.id);
    },

    fileName() {
      const file = this.files.find((file) => file.id === this.fileId);
      if (!file) {
        return '';
      }
      return file.name;
    }
  },

  mounted() {
    if (!this.files.length) {
      this.fetchAllItems();
    }
    this.fetchShipments(this.fileId);
  },

  methods: {
    ...mapActions('files', ['fetchAllItems']),

    /**
     * Fetch shipments associated with a file.
     * @param {number} fileId - The ID of the file to fetch shipments for.
     */
    async fetchShipments(fileId) {
      this.shipmentsLoading = true;

      try {
        const shipments = await EcoChallengeFileApiService.getOrders(fileId);
        this.shipmentsForTable = shipments.getItems();
      } catch (error) {
        this._handleError(error);
      } finally {
        this.shipmentsLoading = false;
      }
    },

    _handleError(error) {
      if (error.response.status === 429) {
        this.$alertError(this.$vuetify.lang.t('$vuetify.messages.APICallsNumberExceeded'));
      } else if (error.response.data.errors) {
        this.$alertError(error.response.data.errors[0].message);
      } else {
        this.$alertError(error.response.data.message);
      }
    },
  }
}
</script>
